import forEachParameter from './forEachParameter';

const updateModel = parameters => {
  forEachParameter(parameters).do((parameter, key) => {
    if (parameter.appendedParameter) {
      delete parameters[key];
    } else {
      parameter.updateOriginalValue();
    }
  });

  return parameters;
};

export default updateModel;
